<template>
  <breadcrumb :title="title" :subTitle="subTitle" :link="link" />
  <div class="container">
    <div class="row">
        <Sidebar />
        <OrderDetails />
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/layouts/breadcrumb.vue";
import Sidebar from '@/components/layouts/sidebar.vue';
import OrderDetails from '@/components/include/profile/order/details.vue';
export default {
  data() {
    return {
      title: this.$t("my_order"),
      subTitle: "",
      link: "",
    };
  },
  components: { breadcrumb, Sidebar, OrderDetails },
};
</script>

<style>
</style>